// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".page[data-v-02abdd53] {\n  background: #eff3f7;\n  padding: 40px;\n  display: flex;\n  justify-content: center;\n  min-height: 100%;\n  width: 100%;\n}\n", ""]);
// Exports
module.exports = exports;
